// extracted by mini-css-extract-plugin
export default {"Button":"qNDHRxep","Text":"UgDKRoGg","Disabled":"BMGVMSob","LightsContainer":"JieRJenh"};